import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation, useNavigate } from 'react-router-dom';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import MapView from './MapView';
import AdminPage from './AdminPage';
import PortalHome from './PortalHome';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ProfilePage from './pages/ProfilePage';
import OAuthCallbackPage from './pages/OAuthCallbackPage';
import LocationDetailPage from './pages/LocationDetailPage';
import AddLocationPage from './pages/AddLocationPage';
import LeaderboardPage from './pages/LeaderboardPage';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider, useAuth } from './context/AuthContext';
import './App.css';

const Navigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, isAuthenticated, logout } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const handleLogout = () => {
    setIsMobileMenuOpen(false);
    logout();
    navigate('/');
  };

  const closeMobileMenu = () => setIsMobileMenuOpen(false);
  const toggleMobileMenu = () => setIsMobileMenuOpen((prev) => !prev);
  
  return (
    <nav className="main-nav">
      <div className="main-nav-header">
        <h2 className="main-nav-title">Pet Buddy Club!</h2>
        <button
          type="button"
          className="main-nav-toggle"
          onClick={toggleMobileMenu}
          aria-label="切換主選單"
          aria-expanded={isMobileMenuOpen}
          aria-controls="main-nav-menu"
        >
          {isMobileMenuOpen ? '✕' : '☰'}
        </button>
      </div>

      <div id="main-nav-menu" className={`main-nav-menu${isMobileMenuOpen ? ' is-open' : ''}`}>
        <div className="main-nav-links">
        <Link
          to="/"
          className={`main-nav-link${location.pathname === '/' ? ' is-active' : ''}`}
          onClick={closeMobileMenu}
        >
          首頁
        </Link>
        <Link
          to="/map"
          className={`main-nav-link${location.pathname === '/map' ? ' is-active' : ''}`}
          onClick={closeMobileMenu}
        >
          地圖
        </Link>
        <Link
          to="/leaderboard"
          className={`main-nav-link${location.pathname === '/leaderboard' ? ' is-active' : ''}`}
          onClick={closeMobileMenu}
        >
          排行榜
        </Link>
        <Link
          to="/admin"
          className={`main-nav-link${location.pathname === '/admin' ? ' is-active' : ''}`}
          onClick={closeMobileMenu}
        >
          管理後台
        </Link>
        </div>

      <div className="main-nav-auth">
        {isAuthenticated ? (
          <>
            <Link
              to="/add-location"
              className={`main-nav-link main-nav-add${location.pathname === '/add-location' ? ' is-active' : ''}`}
              onClick={closeMobileMenu}
            >
              + 新增地點
            </Link>
            <DropdownButton id="user-menu" title={user?.firstName || user?.email} variant="outline-light" size="sm" className="main-nav-user-menu">
              <Dropdown.Item onClick={() => { closeMobileMenu(); navigate('/profile'); }}>我的資料</Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item onClick={handleLogout}>登出</Dropdown.Item>
            </DropdownButton>
          </>
        ) : (
          <>
            <Link
              to="/login"
              className={`main-nav-link${location.pathname === '/login' ? ' is-active' : ''}`}
              onClick={closeMobileMenu}
            >
              登入
            </Link>
            <Link
              to="/register"
              className={`main-nav-link${location.pathname === '/register' ? ' is-active' : ''}`}
              onClick={closeMobileMenu}
            >
              成為會員
            </Link>
          </>
        )}
      </div>
      </div>
    </nav>
  );
};

const OAuthQueryBridge = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname !== '/') {
      return;
    }

    const params = new URLSearchParams(location.search);
    const hasOAuthPayload = params.has('access_token') || params.has('id_token') || params.has('error');

    if (!hasOAuthPayload) {
      return;
    }

    if (!params.has('provider')) {
      params.set('provider', 'google');
    }

    navigate(`/oauth-callback?${params.toString()}`, { replace: true });
  }, [location.pathname, location.search, navigate]);

  return null;
};

const AppContent = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'auto' }}>
      <OAuthQueryBridge />
      <Navigation />
      <div style={{ flex: 1, position: 'relative' }}>
        <Routes>
          <Route path="/" element={<PortalHome />} />
          <Route path="/map" element={<MapView />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/oauth-callback" element={<OAuthCallbackPage />} />
          <Route path="/leaderboard" element={<LeaderboardPage />} />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/location/:id"
            element={
              <ProtectedRoute>
                <LocationDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-location"
            element={
              <ProtectedRoute>
                <AddLocationPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
};

export default App;
